import React from "react";
import PropTypes from "prop-types";


import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';


import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';

import QualificationAccordionSummary from './QualificationAccordionSummary';


import DropZone from "components/Shared/DropZone";


class SavByFoussierPreuveAchat extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat,
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }




    getQualificationData(newState) {
        const { name } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (newState[ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat] === '') {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            code: ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat,
            type: ReclamationQualificationDetailType.Fichier,
            libelle: "Preuve d'achat",
            valeurInteger: newState[ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat],
            valeurString: "Preuve d'achat",
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat);




        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }

    handleChangeFichier = (event) => {
        const { onChange, name } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value.length > 0 ? event.target.value[0] : ''
        };
        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }

    render() {
        const { name } = this.props;

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Preuve d'achat" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                {"La preuve d'achat est obligatoire pour cette prise en charge et ce fournisseur."}

                <DropZone 
                    id={[ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat]}
                    name={[ReclamationQualificationDetailCodes.SavByFoussierPreuveAchat]}
                    onChange={this.handleChangeFichier}

                    label="Preuve d'achat"
                    buttonLabel="Téléverser un fichier"
                    maxNbOfFiles={1}
                />


                </AccordionDetails>
            </Accordion>

        );
    }

}


SavByFoussierPreuveAchat.propTypes = {
    name: PropTypes.string.isRequired,
};

//SavByFoussierPriseEnCharge.defaultProps = {
//};

export default SavByFoussierPreuveAchat;